import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import {
  OptimizerRun,
  OptimizerRunDetail,
  OptimizerRunListParams,
  OptimizerRunUpsertPayload,
} from 'src/models/optimizer-run.model';

@Injectable({
  providedIn: 'root',
})
export class OptimizerRunsService {
  private http = inject(HttpClient);

  list(
    addressListingId: number,
    opts: OptimizerRunListParams = {},
  ): Observable<OptimizerRun[]> {
    let params = new HttpParams();
    if (opts.page !== undefined && opts.page !== null) {params = params.set('page', String(opts.page));}
    if (opts.per_page !== undefined && opts.per_page !== null) {params = params.set('per_page', String(opts.per_page));}
    if (opts.status) {params = params.set('status', opts.status);}
    if (opts.includes) {params = params.set('includes', opts.includes);}

    return this.http.get<OptimizerRun[]>(
      `${environment.api_url}api/v1/customer/address-listings/${addressListingId}/optimizer-runs`,
      { params },
    );
  }

  show(
    addressListingId: number,
    id: number,
    includeListing = false,
  ): Observable<OptimizerRunDetail> {
    let params = new HttpParams();
    if (includeListing) {params = params.set('includes', 'address_listing');}

    return this.http.get<OptimizerRunDetail>(
      `${environment.api_url}api/v1/customer/address-listings/${addressListingId}/optimizer-runs/${id}`,
      { params },
    );
  }

  // Persist a run in the same backend this env reads history from. Upserts by
  // external_job_id (chat-api job UUID): the app writes `running` when a job
  // starts and `success`/`failure` when it finishes, both hitting the same row.
  upsert(
    addressListingId: number,
    payload: OptimizerRunUpsertPayload,
  ): Observable<OptimizerRun> {
    return this.http.post<OptimizerRun>(
      `${environment.api_url}api/v1/customer/address-listings/${addressListingId}/optimizer-runs`,
      payload,
    );
  }
}
